<template>
  <div class="page-container">
    <div class="stat-row">
      <div class="stat-card" style="border-left:4px solid #f53f3f">
        <div class="sc-num" style="color:#f53f3f">{{ p0 }}</div>
        <div class="sc-label">P0 紧急</div>
      </div>
      <div class="stat-card" style="border-left:4px solid #ff7d00">
        <div class="sc-num" style="color:#ff7d00">{{ p1 }}</div>
        <div class="sc-label">P1 警告</div>
      </div>
      <div class="stat-card" style="border-left:4px solid #165dff">
        <div class="sc-num" style="color:#165dff">{{ p2 }}</div>
        <div class="sc-label">P2 提示</div>
      </div>
    </div>

    <div class="search-box">
      <el-select v-model="fLevel" placeholder="告警级别" clearable style="width:140px" @change="loadData">
        <el-option label="P0 紧急" value="0" />
        <el-option label="P1 警告" value="1" />
        <el-option label="P2 提示" value="2" />
      </el-select>
      <el-select v-model="fDone" placeholder="处理状态" clearable style="width:140px" @change="loadData">
        <el-option label="待处理" value="0" />
        <el-option label="已处理" value="1" />
      </el-select>
      <el-button icon="el-icon-refresh" @click="loadData">刷新</el-button>
    </div>

    <div class="table-box">
      <el-table :data="shownAlerts" border v-loading="loading" empty-text="暂无告警" height="100%">
        <el-table-column label="级别" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :style="{ color: scope.row.color, backgroundColor: scope.row.bg, borderColor: 'transparent' }">{{ scope.row.level }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="告警标题" min-width="180" />
        <el-table-column prop="sub" label="类型/对象" min-width="150" />
        <el-table-column prop="detail" label="详情" min-width="220" show-overflow-tooltip />
        <el-table-column prop="time" label="时间" min-width="160" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.done ? 'success' : 'warning'" size="mini">{{ scope.row.done ? '已处理' : '待处理' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-link v-if="!scope.row.done && hasPermission('alert_handle')" type="primary" @click="openHandle(scope.row)">处置</el-link>
            <span v-else style="color:#86909c;font-size:13px">—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="告警处置" :visible.sync="handleShow" width="460px" @close="resetHandle">
      <el-form label-width="90px">
        <el-form-item label="处置结果">
          <el-select v-model="result" style="width:100%">
            <el-option label="已通知驾驶员" value="已通知驾驶员" />
            <el-option label="现场已处理" value="现场已处理" />
            <el-option label="误报忽略" value="误报忽略" />
          </el-select>
        </el-form-item>
        <el-form-item label="处置备注">
          <el-input type="textarea" v-model="note" :rows="3" placeholder="请输入处置备注" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleShow = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitHandle">提交处置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAlerts, handleAlert } from '@/api/sentinel'

export default {
  name: 'AlertIndex',
  data() {
    return {
      alerts: [],
      p0: 0, p1: 0, p2: 0,
      fLevel: '',
      fDone: '',
      loading: false,
      handleShow: false,
      curAlert: null,
      result: '已通知驾驶员',
      note: '',
      saving: false
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    shownAlerts() {
      return this.alerts.filter(a => {
        // a.level 后端为字符串（'P0紧急'/'已闭环'），需映射成数字再与筛选比对
        if (this.fLevel !== '' && String(this.alertLevelNum(a)) !== this.fLevel) return false
        if (this.fDone !== '' && (a.done ? '1' : '0') !== this.fDone) return false
        return true
      })
    }
  },
  methods: {
    hasPermission(k) {
      return this.$store.getters.hasPermission(k)
    },
    // 后端 a.level 为字符串（'P0紧急' / '已闭环'），这里映射为数字以便筛选/统计
    alertLevelNum(a) {
      if (a.done) return -1
      const lv = a.level || ''
      if (lv.indexOf('P0') === 0) return 0
      if (lv.indexOf('P1') === 0) return 1
      if (lv.indexOf('P2') === 0) return 2
      return 2
    },
    loadData() {
      this.loading = true
      getAlerts().then(res => {
        if (res.code === 200) {
          const d = res.data || {}
          const stats = d.stats || []
          this.p0 = (stats.find(s => s.level === 0) || {}).value || 0
          this.p1 = (stats.find(s => s.level === 1) || {}).value || 0
          this.p2 = (stats.find(s => s.level === 2) || {}).value || 0
          this.alerts = d.alerts || []
        }
      }).finally(() => { this.loading = false })
    },
    openHandle(a) {
      this.curAlert = a
      this.result = '已通知驾驶员'
      this.note = ''
      this.handleShow = true
    },
    resetHandle() {
      this.curAlert = null
      this.note = ''
    },
    submitHandle() {
      if (!this.curAlert) return
      const note = this.result + (this.note ? ' · ' + this.note : '')
      this.saving = true
      handleAlert(this.curAlert.id, note).then(res => {
        if (res.code === 200) {
          this.$message.success('处置成功')
          this.handleShow = false
          this.loadData()
        }
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.stat-row { display: flex; gap: 16px; margin-bottom: 16px; }
.stat-card { background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); padding: 14px 22px; min-width: 150px; }
.sc-num { font-size: 28px; font-weight: 700; }
.sc-label { font-size: 13px; color: #86909c; margin-top: 4px; }
.search-box { display: flex; align-items: center; gap: 12px; background: #fff; padding: 12px 16px; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); margin-bottom: 16px; }
.table-box { background: #fff; padding: 16px; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); }
</style>
